import { c as _c } from "react/compiler-runtime";
import styles from "@website/widget/footer/footer-row.module.scss";
import { FooterRowPropertiesType } from "@website/widget/footer/footer.types";
export const FooterRow: FooterRowPropertiesType = t0 => {
  const $ = _c(5);
  const {
    children,
    background
  } = t0;
  const t1 = `${styles["footer-row"]} ${background ? styles[background] : ""}`;
  let t2;
  if ($[0] !== children) {
    t2 = <div className={styles["footer-row-container"]}>{children}</div>;
    $[0] = children;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};